import React, { useState } from "react";
import { Card, Container, Modal } from "react-bootstrap";
import { Button } from "../../../components";

const AssociateCollectCash = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>

            <Container className="g-0" fluid>
                <Card>
                    <Card.Body>
                        <Card.Title className="text-start mb-0">
                            Collect Cash
                        </Card.Title>
                        <hr />
                        <table className="react-table text-start table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Month </th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Collect Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>January 2023</td>
                                    <td>15/01/2023</td>
                                    <td>31/01/2023</td>
                                    <td>20000</td>
                                    <td>
                                        <Button type="button" onClick={handleShow} bname="Collect" name="collect" id="collect" className="btn btn-primary btn-sm text-nowrap"></Button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>
            </Container>
            <Modal aria-labelledby="contained-modal-title-vcenter"
                centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Collect Cash</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Text will go here
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" bname="Paid" name="paid" id="paid" className="btn btn-primary rounded-1"></Button>
                    <Button type="button" bname="Cancel" name="cancel" id="cancel" onClick={handleClose} className="btn btn-light rounded-1"></Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export { AssociateCollectCash }